<template>
   <form @submit.prevent="validate('usernewsletter')" data-vv-scope="usernewsletter" class="mt-5">
      <div class="row">
         <!-- PROMO -->
         <div class="col-12">
            <form-message :messages="getMessage( 'usernewsletter')"></form-message>
         </div>
         <div class="col-12">

            <input type="checkbox" v-model="form.newsletter" name="newsletter"
                id="register__promo" class="field__checkbox">
            <label for="register__promo" class="field__checkbox__label field__checkbox__label--lg">
               {{ t('userdata.newsletter.label') }}
            </label>
         </div>
      </div>
      <div class="row mt-4" v-if="user.has_newsletter !== form.newsletter">
         <div class="col-12 d-flex justify-content-end">
            <button class="btn btn-primary btn-sm" type="submit">
               {{ t('general.btn.submit') }}
            </button>
         </div>
      </div>
   </form>

</template>

<script>
import Vuex from 'vuex';

import {mixins} from "@/components/user/UserData/user_helpers";
import FormMessage from "@/components/parts/form-message";

export default {
   name: "newsletter",
   mixins:[mixins],
   components:{
      FormMessage,
   },
   data() {
      return {

         loading: [],

         form: {

            newsletter: false
         }
      }
   },
   watch: {
      user(val) {
         if (typeof val.has_newsletter !== 'undefined') {

            this.form.newsletter = val.has_newsletter;
         }
      }
   },
   computed:{
      ...Vuex.mapState([
         'lang',
         'loaderList'
      ]),
      ...Vuex.mapGetters({
         user: 'getUser',
         userLogedIn: 'getUserStatus',
         details: 'getUserDetails'
      }),
   },
   mounted() {

      this.form.newsletter = this.user.has_newsletter;

   },
   methods:{
      validate(scope) {
         this.$validator.validateAll(scope).then((result) => {

            if (result) {
               this.deleteMessage(scope);
               this.updateNewsletter(scope);
            }


         });
      },







      updateNewsletter(scope) {


         this.$store.commit('addLoad', scope);

         //Push to vuex new data values to send it to REST
         this.$store.dispatch('saveUserData', {
            'has_newsletter': this.form.newsletter ? 1 : 0,
         }).then((responce) => {

            //Finish load bar
            this.$store.commit('endLoad', scope);

            //Error handling
            if (responce.data.status === 'SUCCESS') {

               //Show message that all successfully changed
               this.addMessage({
                  scope: scope,
                  state: 'success',
                  text: this.t('user.data.' + scope + '.change.success')
               });


               setTimeout(() => {
                  this.errors.clear(scope);
               }, 50);
            } else {
               let msg;
               if (typeof responce.data.error !== 'undefined') {
                  msg = this.t('userdata.error.' + responce.data.error.code);
               } else {
                  msg = responce.data.message
               }
               this.addMessage({
                  scope: scope,
                  state: 'danger',
                  text: msg
               });
            }

         })
      },
   }
}
</script>

<style scoped>

</style>
